<template>
    <div class="c-form-item c-date-picker" :class="[{'c-form-item--horizontal': horizontal},fluid ? 'c-form-item--fluid c-date-picker--fluid': '', error ? 'c-form-item--error':'']">
        <label class="c-label datepicker__label">{{ label }}</label>
        <div class="u-pos-relative" :class="{'u-fullwidth': fluid}">
            <v-date-picker
                    mode="single"
                    v-model="selectedValue"
                    :date-formatter="dateFormatter"
                    :available-dates='availableDates'
                    :input-class="inputClass"
                    :popover-visibility="popoverVisibility"
                    :popover-expanded="fluid">
            </v-date-picker>

            <v-error v-if="error">
                <slot name="error">{{ error }}</slot>
            </v-error>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue'
    import VCalendar from 'v-calendar';
    import VLabel from './Label.vue'
    import VError from './Error.vue'
    import 'v-calendar/lib/v-calendar.min.css';

    // Use v-calendar, v-date-picker & v-popover components
    Vue.use(VCalendar);

    export default {
        components: {
            VLabel,
            VCalendar,
            VError
        },
        methods: {
            dateFormatter(date) {
                return Vue.moment(date).format('DD-MM-YYYY');
            }
        },
        computed: {
            selectedValue: {
                get() {
                    return this.value ? new Date(this.value) : null
                },
                set(value) {
                    this.$emit('input', Vue.moment.utc(value).local().format());
                }
            }
        },
        props: {
            popoverVisibility: {type: String, default: 'focus'},
            inputClass: {type: String, default: 'c-input c-form-element'},
            label: {type: String},
            fluid: {type: Boolean, default: true},
            error: {type: String},
            horizontal: {type: Boolean, default: true},
            value: [String, Date],
            availableDates: {type: Object, default: () => ({ start: new Date(), end: null })}
        },
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-date-picker--fluid {
        .popover-container {
            width: 100%;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/form/Datepicker.vue